class ScopePlan {
	id = '';
	name = '';
	tierName = '';
	addOns = [];
	addOnPackages = [];
	currentAddOnsDisplayText = '';
	tierId = '';
	description = '';
	interval = '';
	displayInterval = '';
	amount = 0;
	details = null;
	paymentMethodRequired = false;
	customBilling = false;
	active = false;
	hasTrial = false;
	isTrial = false;
	isTierTrial = false;
	isPro = false;
	isStarter = false;
	isUltimate = false;
	isLegacy = false;
	isCurrent = false;
	isPrepaid = false;
	isCurrentTier = false;
	displayName = '';
	featureList1 = [];
	featureList2 = [];
	isAtSubCountLimit = false;
}

export default ScopePlan;



// WEBPACK FOOTER //
// ./src/store/models/scope-plan.js